import React from 'react';
import PageHero from '@/components/PageHero';
import SEO from '@/components/SEO';
import { OVERVIEW } from '@/data/content';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

export default function Overview() {
  return (
    <div>
      <SEO
        title="Overview"
        description="About Kress & Associates and the Drug and Alcohol Awareness program serving schools across Western Pennsylvania."
        path="/overview"
      />
      <PageHero
        title="Overview"
        subtitle="About Kress & Associates and the Drug and Alcohol Awareness program."
        image="https://images.pexels.com/photos/37758744/pexels-photo-37758744.jpeg?auto=compress&cs=tinysrgb&w=1920"
        crumbs={['Overview']}
      />
      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="space-y-6">
          {OVERVIEW.paragraphs.map((p, i) => (
            <p key={i} className="text-slate-700 leading-[1.9] text-[15.5px]">{p}</p>
          ))}
        </div>

        <div className="mt-14 p-8 bg-slate-50 border-l-4 border-amber-400 rounded-md">
          <h3 className="font-serif text-2xl font-bold text-[#0b2545] mb-3">
            Learn more about the program
          </h3>
          <p className="text-slate-600 mb-5">
            Read a detailed breakdown of the curriculum, presentation format, and cost-effectiveness.
          </p>
          <Button asChild className="bg-[#0b2545] hover:bg-[#123a6b] text-white">
            <Link to="/program">
              View The Program <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
